import React from 'react';
import OddWithDesc from '../common/OddWithDesc';
import { classIf } from '../data/utils';
import { navigate } from '../router/Link';
import { getEventUrl } from './Prematch';
import Img from '../common/Img';
import OddSelector from '../common/OddSelector';
import FavoriteEventToggle from '../common/favorite-events/FavoriteEventToggle';
import { getUniqueId } from './Tournament';

export default function EventPreview(props) {
    const event = props.data;
    const bet = event.bets[0];
    const odds = bet.odds;
    const url = getEventUrl(event);
    
    function handleClick() {
        navigate(url);
    }

    return (
        <div className={"c_31" + classIf(props.active, 'active')} data-type={props.type} onClick={handleClick}>
            {props.showFullDesc &&
                <div className="c_31_1">
                    <span className="c_31_1_1">{event.tournamentDesc}</span>
                </div>
            }
            <div className="c_31_2">
                <span className="c_31_2_1">{event.dateShort || event.date}, {event.time}</span>
                <div className="c_31_2_2">
                    <span className="c_31_2_2_1">{event.alias}</span>
                </div>
            </div>
            <div className="c_31_3">
                <div className="c_31_3_1">
                    <span className="c_31_3_1_1">{event.team1}</span>
                    <span className="c_31_3_1_1">{event.team2}</span>
                </div>
                {props.showPinButton &&
                    <div className="c_31_3_2">
                        <FavoriteEventToggle className="c_31_3_2_1" id={getUniqueId(event)} />
                    </div>
                }
            </div>
            <div className="c_31_4">
                <div className="c_31_4_1">
                    {bet.desc}
                </div>
            </div>
            <div className="c_31_5">
                <div className="c_31_5_1">
                    {odds.length > 3 ?
                        <OddSelector odds={odds} />
                        :
                        (bet.odds.map(o =>
                            <OddWithDesc key={o.uniqueId} data={o} />
                        ))
                    }
                </div>
                <div className="c_31_5_2">
                    <span className="c_31_5_2_1">+{event.plus}</span>
                    <Img className="c_31_5_2_2" src="icon_chevron.svg" height="16px" width="16px" data-rotate="270" />
                </div>
            </div>
        </div>
    );
}
